/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const StartNativeLoginBody = zod.object({
  channel: zod.enum(['email', 'phone']),
  homeRegion: zod
    .enum(['au', 'us'])
    .optional()
    .describe("One of OnEarly's regions: `au` (Australia) or `us` (United States)."),
  identifier: zod.string().min(1),
});

export type StartNativeLoginBody = zod.input<typeof StartNativeLoginBody>;
export type StartNativeLoginBodyOutput = zod.output<typeof StartNativeLoginBody>;
